import { render, staticRenderFns } from "./CreateSchoolModal.vue?vue&type=template&id=3cfeb523&"
import script from "./CreateSchoolModal.vue?vue&type=script&lang=js&"
export * from "./CreateSchoolModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSchoolModal.vue?vue&type=style&index=0&id=3cfeb523&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports